import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Tag,
  TagCloseButton,
  TagLabel,
} from "@chakra-ui/react";
import { useState } from "react";

import { RanaModal } from "@nens/ranalib";

import { SaveSchematisationDataType } from "../management/schematisations/SchematisationsDetail";
import { SaveSimulationDataType } from "../management/simulations/SimulationDetail";

export interface EditTagProps {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  tags: string[];
  saveData?: SaveSchematisationDataType | SaveSimulationDataType;
}

export function EditTags({ title, isOpen, onClose, tags, saveData }: EditTagProps) {
  const [updatedTags, setUpdatedTags] = useState(tags);
  const [newTag, setNewTag] = useState("");

  const deleteTag = (tag: string) => {
    setUpdatedTags(updatedTags.filter((item) => item !== tag));
  };

  const addTag = () => {
    if (newTag !== "") {
      setUpdatedTags(updatedTags.concat(newTag));
      setNewTag("");
    }
  };

  const saveSchematisationTags = async () => {
    if (saveData) {
      const newUpdatedTags = updatedTags;
      if (newTag) {
        newUpdatedTags.push(newTag);
        setNewTag("");
      }
      saveData("tags", newUpdatedTags);
    }
    onClose();
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setNewTag(event.target.value.toString());
  const handleClick = () => addTag();
  return (
    <RanaModal
      isOpen={isOpen}
      onClose={onClose}
      topBar={`Edit ${title || "Tags"}`}
      buttons={[
        <Button variant="primary" key="save" onClick={saveSchematisationTags}>
          Save
        </Button>,
      ]}
    >
      {updatedTags.map((tag) => (
        <Box key={tag} mb={1}>
          <Tag key={tag} borderRadius="full" variant="solid">
            <TagLabel>{tag}</TagLabel>
            <TagCloseButton
              onClick={() => {
                deleteTag(tag);
              }}
            />
          </Tag>
        </Box>
      ))}
      <Flex mb={2}>
        <Input
          placeholder="Tag"
          size="sm"
          value={newTag}
          onChange={handleChange}
          onKeyDown={(event) => event.key === "Enter" && addTag()}
        />
        <IconButton
          size={"sm"}
          ml={1}
          aria-label="Add tag"
          alignSelf="center"
          icon={<AddIcon />}
          onClick={handleClick}
        />
      </Flex>
    </RanaModal>
  );
}
